import React from 'react';
import { motion } from 'framer-motion';
import { Code, Palette, Database, Globe } from 'lucide-react';

const SERVICES = [
  {
    icon: Code,
    title: 'Web Development',
    description: 'Full-stack web applications built with modern, maintainable technologies.',
  },
  {
    icon: Palette,
    title: 'UI/UX Design',
    description: 'Interfaces that feel intuitive first, and look good as a result.',
  },
  {
    icon: Database,
    title: 'Database Design',
    description: 'Schemas and queries built for clarity, integrity, and speed.',
  },
  {
    icon: Globe,
    title: 'API Development',
    description: 'RESTful APIs and backend services designed to scale cleanly.',
  },
];

const Services = () => {
  return (
    <section id="services" className="relative py-20 sm:py-28 bg-ink-950 overflow-hidden font-body">
      <div className="absolute inset-0 bg-grain pointer-events-none" />
      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-14"
        >
          <span className="section-eyebrow">What I do</span>
          <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-bold font-display">
            <span className="text-gradient">End-to-end, not just the front page</span>
          </h2>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {SERVICES.map((service, index) => (
            <motion.div
              key={service.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.3 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              whileHover={{ y: -6 }}
              className="glass glass-hover rounded-2xl p-7 text-left"
            >
              <div className="w-12 h-12 rounded-xl flex items-center justify-center bg-gradient-to-br from-mint-400/20 to-indigo-400/20 text-mint-400 mb-6">
                <service.icon className="w-6 h-6" />
              </div>
              <h3 className="text-lg font-bold text-white font-display mb-2">{service.title}</h3>
              <p className="text-sm text-white/50 leading-relaxed">{service.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
